import { Badge, Button, Card, CardContent, CardHeader, CardTitle } from "@repo/ui";
import { BedDouble, Leaf, ShowerHead, ThermometerSun, Users, Wifi } from "lucide-react";
import { Link } from "react-router-dom";

export default function Accommodation() {
  const tents = [
    {
      type: "King Bed Tent",
      subtitle: "Sleeps 2",
      price: 2500,
      count: 4,
      amenities: ["Private bathroom", "Hot shower", "A/C", "Wi‑Fi", "Breakfast optional"],
    },
    {
      type: "Double‑Queen Tent",
      subtitle: "Sleeps up to 4",
      price: 3500,
      count: 2,
      amenities: ["Private bathroom", "Hot shower", "A/C", "Wi‑Fi", "Breakfast optional"],
    },
  ];
  return (
    <section className="max-w-6xl mx-auto px-4 py-12">
      <div className="mb-8">
        <h1 className="text-3xl font-semibold tracking-tight">Accommodation</h1>
        <p className="text-muted-foreground mt-2">
          Cozy, nature‑immersed tents with hotel‑level comfort.
        </p>
      </div>
      <div className="grid md:grid-cols-2 gap-6">
        {tents.map((t) => (
          <Card key={t.type} className="overflow-hidden">
            <div className="aspect-[16/9] bg-muted" aria-hidden />
            <CardHeader>
              <CardTitle className="flex items-center gap-2">
                <Leaf className="size-5 text-primary" /> {t.type}
              </CardTitle>
              <div className="flex items-center gap-2 text-sm text-muted-foreground">
                <Users className="size-4" /> {t.subtitle}
                <Badge variant="secondary">THB {t.price.toLocaleString()}</Badge>
              </div>
            </CardHeader>
            <CardContent className="space-y-3">
              <div className="flex flex-wrap gap-3 text-sm text-foreground/80">
                <span className="inline-flex items-center gap-1">
                  <BedDouble className="size-4" /> Premium bedding
                </span>
                <span className="inline-flex items-center gap-1">
                  <ShowerHead className="size-4" /> Hot shower
                </span>
                <span className="inline-flex items-center gap-1">
                  <ThermometerSun className="size-4" /> A/C
                </span>
                <span className="inline-flex items-center gap-1">
                  <Wifi className="size-4" /> Wi‑Fi
                </span>
              </div>
              <div className="flex gap-2">
                <Button asChild>
                  <Link to={`/booking?type=${encodeURIComponent(t.type)}`}>Book</Link>
                </Button>
                <Button asChild variant="outline">
                  <Link to="/gallery">View Photos</Link>
                </Button>
              </div>
              <p className="text-xs text-muted-foreground">
                {t.count} tents available in this category.
              </p>
            </CardContent>
          </Card>
        ))}
      </div>
    </section>
  );
}
